var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.6135450817abd0001ae72a95e019e9ca.svg#Q';
                    var viewUrl = 'sprites.6135450817abd0001ae72a95e019e9ca.svg#view-Q';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 2110 359.6',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };